import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  useHistory,
  useLocation,
} from "react-router-dom";
import { Tab } from "@headlessui/react";
import { VendorInvoiceTabs } from "./VendorInvoiceTabs";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilState, useRecoilValue } from "recoil";
import { selectedVIPTab } from "./InvoiceManager/atoms/atoms";
import { InvoiceManager } from "./InvoiceManager";
import { InvoiceCapture } from "./InvoiceCapture";
import { ForReview } from "./ForReview";
import { SubmittedToAcumatica } from "./SubmittedToAcumatica";
import { Completed } from "./Completed";
import { Voided } from "./Voided";

interface Props {}

export const VendorInvoice: React.FC<Props> = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const userPermissions = useRecoilValue(permissionsSelector);
  const currentTabs = VendorInvoiceTabs.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const [selectedIndex, setSelectedIndex] = useRecoilState(selectedVIPTab);
  const defaultTab = currentTabs.findIndex((c) => pathname.includes(c.to));

  useEffect(() => {
    if (defaultTab < 0) {
      history.push(currentTabs[0]?.to);
      setSelectedIndex(0);
    } else {
      setSelectedIndex(defaultTab);
    }
  }, [defaultTab]);

  return (
    <div className="py-4 px-8">
      {selectedIndex !== 0 && (
        <div className="lg:border-t lg:border-b lg:border-gray-200">
          <nav className="" aria-label="Progress">
            <ol
              role="list"
              className="rounded-md overflow-hidden lg:flex lg:border-l lg:border-r lg:border-gray-200 lg:rounded-none"
            >
              {currentTabs.map((item, index) => {
                const urlPath = {
                  pathname: item.to,
                };

                return (
                  <li
                    className={`${
                      index === 6
                        ? "relative overflow-hidden border-r-2"
                        : "relative overflow-hidden "
                    }`}
                  >
                    <div className="border border-gray-200 overflow-hidden border-b-0 rounded-t-md lg:border-0">
                      <div
                        onClick={() => {
                          setSelectedIndex(index);
                          history.push(urlPath);
                        }}
                        className="group"
                      >
                        <span
                          className="absolute top-0 left-0 w-1 h-full bg-transparent"
                          aria-hidden="true"
                        ></span>
                        <span
                          className={`${
                            selectedIndex === index
                              ? "border-b-2 border-secondary px-6 py-2 flex items-start text-sm font-medium cursor-pointer"
                              : "hover:border-b-2 hover:border-secondary px-6 py-2 flex items-start text-sm font-medium cursor-pointer"
                          }`}
                        >
                          <span className="flex-shrink-0 mt-1">
                            <span
                              className={`${
                                selectedIndex === index
                                  ? "w-8 h-8 flex items-center justify-center border-2 border-secondary text-secondary bg-white  rounded-full"
                                  : "w-8 h-8 flex items-center justify-center border-2 border-gray-500 bg-white  rounded-full"
                              }`}
                            >
                              {/* <!-- Heroicon name: solid/check --> */}
                              {item.icon}
                            </span>
                          </span>
                          <span className="mt-0.5 ml-2 min-w-0 flex flex-col">
                            <span
                              className={`${
                                selectedIndex === index
                                  ? "text-xxs font-semibold tracking-wide uppercase text-secondary whitespace-nowrap"
                                  : "text-xxs font-semibold tracking-wide uppercase text-gray-600 whitespace-nowrap"
                              }`}
                            >
                              {item.title}
                            </span>
                            <span className="text-xs1 font-medium text-gray-500 -mt-1">
                              {item.title === "Invoice Manager"
                                ? "Vendor"
                                : "Invoice"}
                            </span>
                          </span>
                        </span>
                      </div>
                      {/* <!-- Separator --> */}
                      {index !== 0 && (
                        <div
                          className="hidden absolute top-0 left-0 w-3 inset-0 lg:block"
                          aria-hidden="true"
                        >
                          <svg
                            className="h-full w-full text-gray-300"
                            viewBox="0 0 12 82"
                            fill="none"
                            preserveAspectRatio="none"
                          >
                            <path
                              d="M0.5 0V31L10.5 41L0.5 51V82"
                              stroke="currentcolor"
                              vector-effect="non-scaling-stroke"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>
      )}
      <div>
        {currentTabs?.map(
          (child, index) =>
            selectedIndex === index && React.createElement(child.component)
        )}
        {/* {selectedIndex === 0 && <InvoiceManager />}
        {selectedIndex === 1 && <InvoiceCapture />}
        {selectedIndex === 2 && <ForReview />}
        {selectedIndex === 3 && <SubmittedToAcumatica />}
        {selectedIndex === 4 && <Completed />}
        {selectedIndex === 5 && <Voided />} */}
      </div>
    </div>
  );
};
